var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-layout',{attrs:{"title":"Crea tu cuenta","subtitle":'Compra mas rapido en ' + _vm.commerce_name}},[_c('form-register'),_c('verify-code')],1)}
var staticRenderFns = []

export { render, staticRenderFns }